import styled from "styled-components";
import { colors } from './../../variables';

export const Message = styled.div`
  height: 50px;
  background-color: ${colors.back};
  color: ${colors.main}
`;